<template>
    <div class="FullObjectParams">
        <div class="FullObjectParams__item" v-for="(value, paramName) of params" :key="paramName">
            <FullObjectParam :name="paramName" :value="value" />
        </div>
    </div>
</template>

<script>

import FullObjectParam from "@/components/Object/FullObjectParam";

export default {
    name: "FullObjectParams",
    props: {
        params: Object,
    },
    components: {
        FullObjectParam,
    }
}
</script>

<style lang="scss">
.FullObjectParams {
  display: flex;
  justify-content: space-between;
  align-items: stretch;

  &__item {

  }
}
</style>